import styled from 'styled-components';
import { ContentWidthWrapper } from '@pass-frontend/common/components/content-width-wrapper/ui';
import { useIntl } from '@pass-frontend/common/i18n';
import { GymPartnersDataProps } from '@pass-frontend/features/standalone/data-access';
import { MEDIA_QUERY } from '@pass-frontend/utility/style-helpers';

const StyledGymPartners = styled.div`
  padding: 24px 0;

  .title {
    margin-bottom: 32px;
  }

  .image-section {
    display: grid;
    grid-template-columns: repeat(2, auto);
    grid-gap: 24px 20px;
    align-items: center;
    justify-content: center;

    ${MEDIA_QUERY.tablet} {
      grid-template-columns: repeat(3, auto);
    }

    ${MEDIA_QUERY.desktop} {
      display: flex;
      justify-content: space-between;
    }
  }

  .image-wrapper {
    width: 120px;

    ${MEDIA_QUERY.desktop} {
      width: 150px;
    }
  }

  ${MEDIA_QUERY.desktop} {
    padding: 40px 0;
  }
`;

export function GymPartners(props: GymPartnersDataProps) {
  const { titleKey, images } = props;
  const { t } = useIntl();

  return (
    <StyledGymPartners className="has-bg-warm-white">
      <ContentWidthWrapper>
        <>
          <h2 className="is-h2 has-text-blue-1 has-text-centered title">
            {t(titleKey)}
          </h2>
          <div className="image-section">
            {images.map(({ url, altTextKey }, key) => (
              <div
                className="image-wrapper"
                data-testid="gymPartnerImage"
                key={key}
              >
                <img src={url} alt={t(altTextKey)} />
              </div>
            ))}
          </div>
        </>
      </ContentWidthWrapper>
    </StyledGymPartners>
  );
}
